import React from "react";
import IncentiveSheet from "./ItModule/IncentiveSheet";
import MasterSheet from "./ItModule/MasterSheet";
import TableIncentive from "./TableIncentive";
import IncentiveModuleLayout from "./IncentiveModuleLayout";

const ItModule = () => {
  const itModuleTabs = [
    {
      title: "Master Sheet",
      page: <MasterSheet />,
      type: "main",
    },
    {
      title: "Incentive Sheet",
      page: <IncentiveSheet />,
      type: "main",
    },
  ];
  return (
    <IncentiveModuleLayout
      moduleName="IT"
      initialCards={[]}
      tabs={itModuleTabs}
      tabId="it-module"
    />
  );
};

export default ItModule;
